import React, { useState, useEffect, useCallback } from 'react';
import Swal from 'sweetalert2';
import { adminFetch } from '../../utils/adminApi';
import SeoFieldsForm from './SeoFieldsForm';
import SectionBuilder from './SectionBuilder';
import './AdminSeoPanels.css';

const emptyLp = { title: '', sections: [], hideHeaderFooter: false, status: 'draft' };

const LandingPagesPanel = () => {
  const [pages, setPages] = useState([]);
  const [form, setForm] = useState(emptyLp);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    const res = await adminFetch('/api/landing-pages?all=true');
    if (res.ok) setPages(await res.json());
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    setLoading(true);
    const url = editingId ? `/api/landing-pages/${editingId}` : '/api/landing-pages';
    const res = await adminFetch(url, { method: editingId ? 'PUT' : 'POST', body: JSON.stringify(form) });
    setLoading(false);
    if (res.ok) {
      Swal.fire('Saved', 'Landing page saved.', 'success');
      setForm(emptyLp);
      setEditingId(null);
      load();
    } else Swal.fire('Error', 'Could not save.', 'error');
  };

  return (
    <div className="admin-seo-panel animate-in">
      <h2 className="admin-seo-panel-title">{editingId ? 'Edit Landing Page' : 'Create Landing Page'}</h2>
      <p className="admin-seo-panel-desc">Campaign pages at /lp/your-slug — hide header/footer for focused conversion pages.</p>

      <section className="admin-seo-section">
        <h3>Page Settings</h3>
        <div className="form-row">
          <label>Page Title
            <input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="Summer Sale 2026" />
          </label>
          <label>Status
            <select value={form.status || 'draft'} onChange={(e) => setForm({ ...form, status: e.target.value })}>
              <option value="draft">Draft</option>
              <option value="published">Published</option>
            </select>
          </label>
        </div>
        <label className="flag-label" style={{ maxWidth: '100%' }}>
          <input type="checkbox" checked={!!form.hideHeaderFooter} onChange={(e) => setForm({ ...form, hideHeaderFooter: e.target.checked })} />
          Hide site header & footer (distraction-free campaign page)
        </label>
      </section>

      <section className="admin-seo-section">
        <h3>Page Sections</h3>
        <SectionBuilder sections={form.sections || []} onChange={(sections) => setForm({ ...form, sections })} />
      </section>

      <SeoFieldsForm title="Landing Page SEO" slugPrefix="/lp/" values={form} onChange={(seo) => setForm({ ...form, ...seo })} />

      <div className="admin-seo-actions">
        <button type="button" className="action-submit-btn" onClick={save} disabled={loading}>{editingId ? 'Update' : 'Create'} Landing Page</button>
        {editingId && <button type="button" className="action-submit-btn secondary" onClick={() => { setForm(emptyLp); setEditingId(null); }}>Cancel</button>}
      </div>

      {pages.length > 0 && (
        <section className="admin-seo-section" style={{ marginTop: 24 }}>
          <h3>Your Landing Pages</h3>
          {pages.map((p) => (
            <div key={p._id} className="list-row">
              <span>
                <strong>{p.title}</strong> — /lp/{p.slug || '…'} ({p.status})
                {p.hideHeaderFooter && ' · no header/footer'}
              </span>
              <button type="button" className="action-submit-btn secondary" onClick={() => { setForm(p); setEditingId(p._id); }}>Edit</button>
            </div>
          ))}
        </section>
      )}
    </div>
  );
};

export default LandingPagesPanel;
